Selector.View.QuestionTabListView = Backbone.View.extend(
/** @lends Selector.View.QuestionListView# */
{
	initialize: function() {

    	_.bindAll(this, "render");
        this.collection.on('reset',this.render);
        this.collection.on('change',this.render);
        
	},
	
	/** Render function */
	render: function() {

        //allows app to be loaded on page without the DOM element being present
        this.setElement($(".e_selector_tabs"));

        if (this.collection.groups) {
            //group up the questions into categories
            var groupTabsTemplate = _.template($('#selector_group_tabs').html());
            this.$el.html(groupTabsTemplate({groups: ele.selector.data.GROUPS, groupActive: this.collection.groupActive}));
        } else {
            var fragment = document.createDocumentFragment();
            //just show 1 question per tab
            this.collection.each(function (model) {
                if (
                    ele.selector.data.CONFIG.SELECTORTYPE === "landscape" || //only landscape as no conditional questions
                    model.get("ANSWER") !== null ||
                    model.get("CURRENT") !== false ||
                    model.get("ACTIVE") !== false
                ) {
                    var modelView = new Selector.View.QuestionTabView({model: model});
                    fragment.appendChild(modelView.render().el);
                }
            }, this);
            this.$el.html(fragment);
        }

        $('.tooltip').tooltip({
            hide: 50,
            show: 50,
            position: { my: "center top",  at: "center bottom"},
            content: function(){return $(this).data("tooltip");}
        });

		return this;
	}

});